import React, { useEffect, useState, useRef } from 'react';
import styles from './AdViseStep8.module.css';
import FeedEditor from '../Editor/FeedEditor';
import FeedPreview from '../Editor/FeedPreview';

const AdViseStep8 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {    
    const [conti, setConti] = useState(null);
    const [isPreviewMode, setIsPreviewMode] = useState(false);

    const backFunction = () => {
        const confirm = window.confirm("수정 사항들이 모두 초기화됩니다.\n\n뒤로 가시겠습니까?");

        if(confirm){
            if(stepProps[8].file)
                setAdViseStep(20);
            else if(stepProps[2]=='advise')
                setAdViseStep(7);
            else
                setAdViseStep(2);
        }
    };

    const getOriginalImages = () => stepProps[7].originalImages || [];

    useEffect(()=>{
        if(stepProps[7].conti!=null){
            const selectedImageUrls = getOriginalImages();
            const pre_conti = stepProps[7].conti;

            const result_conti = pre_conti.map(page => ({
                ...page,
                image: selectedImageUrls[page.image_index]
            }));
        
            setConti(result_conti);   
        }
        else{
            setConti([]);
        }
        //setConti(test_conti);
    }, [])

    return (
        <div className={styles.outerframe}>
            {conti && <FeedEditor initialConti={conti} backFunction={backFunction} setStepProps={setStepProps} stepProps={stepProps} setIsPreviewMode={setIsPreviewMode}/>}
            {isPreviewMode &&
                <div className={styles.previewOverlay}>
                    <FeedPreview setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop} setIsPreviewMode={setIsPreviewMode}/>
                </div>
            }
        </div>
    );
}

export default AdViseStep8;